import dayjs from 'dayjs';
import { atom, selector } from 'recoil';
import { localStorageEffect } from '../storage';
import { EstimateShipping, ProgressShipping } from './estimateShipping.type';

const estimateShipping = atom<EstimateShipping>({
    key: 'estimateShipping',
    default: {
        loading: false,
        sku: '',
        estimate: [],
        progress: []
    },
    effects: [localStorageEffect('estimateShipping')]
});

const estimateShippingSelector = selector({
    key: 'estimate-shipping-selector',
    get: ({ get }) => {
        const currentEstimate = get(estimateShipping);
        try {
            const shippingData = currentEstimate?.estimate;

            const progress =
                shippingData?.map((s) => {
                    const { placed_ships_from, placed_ships_to, ships_delivered_from, ships_delivered_to } = s;
                    const currentDate = dayjs().format('ddd, MMM DD');
                    const placedShipsFrom = dayjs().add(Number(placed_ships_from), 'day');
                    const placedShipsTo = dayjs().add(Number(placed_ships_to), 'day');
                    const shipsDeliveredFrom = dayjs().add(Number(ships_delivered_from), 'day');
                    const shipsDeliveredTo = dayjs().add(Number(ships_delivered_to), 'day');

                    const progressData = {
                        steps: [
                            { title: 'Order Placed', date: currentDate, icon: 'bag-tick' },
                            {
                                title: 'Delivering',
                                date: `${placedShipsFrom.format('MMM DD')}-${placedShipsTo.format('DD')}`,
                                icon: 'truck-fast'
                            },
                            {
                                title: 'Received',
                                date: `${shipsDeliveredFrom.format('MMM DD')}-${shipsDeliveredTo.format('DD')}`,
                                icon: 'box'
                            }
                        ],
                        type: s?.type,
                        currentDate,
                        placedShipsFrom,
                        placedShipsTo,
                        shipsDeliveredFrom,
                        shipsDeliveredTo,
                        carrier_code: s?.carrier_code,
                        shipping_cost: s?.shipping_cost,
                        originalData: s
                    };

                    return progressData as ProgressShipping;
                }) || [];

            return {
                ...currentEstimate,
                progress
            };
        } catch (error) {
            console.error(error, 'countries-selector');

            return {
                ...currentEstimate,
                progress: []
            };
        }
    }
});
export default { estimateShippingSelector, estimateShipping };
